/**
 * 渠道归因：捕获链接令牌 → 本地持久化 → 注册时提交。
 *
 * 注意：链接里带的是【链接令牌】，不是推荐码。前端只原样存、原样交，
 * 推荐码由后端在注册写入时自行解析产生（展示用的码走 services/referral.js，仅供回显）。
 */

/** 推荐参数名。命名常量 —— 想换成更中性的名字只改这一处。 */
export const REFERRAL_PARAM = 'ref'

/** 归因窗口（天）。业务口径，唯一调节点 —— 改这一个数字即可。 */
export const REFERRAL_TTL_DAYS = 3

const STORAGE_KEY = 'cfgl_referral'
const TTL_MS = REFERRAL_TTL_DAYS * 24 * 60 * 60 * 1000

function read() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

function write(value) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    /* localStorage 被禁用或写满：降级为无归因，绝不影响注册流程 */
  }
}

function clear() {
  try {
    localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* 同上 */
  }
}

/**
 * 捕获当前 URL 上的推荐参数。
 *
 * 规则：
 * - 无参数 → 空操作，【不覆盖、不清除】已存值（自然流量不得冲掉付费渠道归因）
 * - 同一令牌 → 只刷新 lastTouchAt 与 expireAt，firstLandingAt / landingPath 保持不变
 * - 新令牌   → 整体替换（last-paid-touch）
 *
 * @returns {boolean} 是否确实捕获到了参数（调用方据此决定是否抹地址栏）
 */
export function captureReferral(search, pathname) {
  let token = null
  try {
    token = new URLSearchParams(search || '').get(REFERRAL_PARAM)
  } catch {
    return false
  }
  if (!token || !token.trim()) return false
  token = token.trim()

  const now = Date.now()
  const prev = read()

  if (prev && prev.token === token) {
    write({ ...prev, lastTouchAt: now, expireAt: now + TTL_MS })
  } else {
    write({
      token,
      firstLandingAt: now,
      lastTouchAt: now,
      // 只存路径、不存完整查询串：URL 上以后可能挂搜索词、手机号、第三方 token，
      // 而客户表日后要导出给合作方对账。少存一点，少一类事后才发现的问题。
      landingPath: pathname || '/',
      expireAt: now + TTL_MS,
    })
  }
  return true
}

/** 读取有效归因；已过期则清除并返回 null。 */
export function readReferral() {
  const v = read()
  if (!v || !v.token) return null
  if (!v.expireAt || Date.now() > v.expireAt) {
    clear()
    return null
  }
  return { token: v.token, landingPath: v.landingPath || '/' }
}
